var map = {
	"./excel.svg": 55600,
	"./microsoft365-admin.svg": 181801,
	"./microsoft365.svg": 500907,
	"./powerpoint.svg": 59288,
	"./sharepoint.svg": 31146,
	"./slack.svg": 860917,
	"./word.svg": 992535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 761597;